module.exports = __webpack_public_path__ + "static/media/image-icon.1e9b5bfb.svg";